export default "__VITE_ASSET__CIJ_7GkQ__"